import React from "react";
import { HelpCircle } from "lucide-react";
import { WelcomeModal, resetWelcome } from "./WelcomeModal";

/**
 * A single persistent "?" help button that anyone can click to reopen the
 * onboarding tour. Mount it near the top of the shell; it's self-contained
 * and toggles the WelcomeModal internally.
 */
export function HelpButton() {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    resetWelcome(); // ensure the modal always starts from step 1
    setOpen(true);
  };

  return (
    <>
      <button
        data-testid="help-button"
        onClick={handleOpen}
        title="How does Lien Scout work?"
        className="fixed bottom-4 left-4 z-50 flex items-center gap-2 border-2 border-black bg-yellow-400 px-3 py-2 font-display font-semibold text-xs shadow-brutal-sm hover:bg-yellow-300"
        aria-label="Open Lien Scout tour"
      >
        <HelpCircle size={14} strokeWidth={2.5} />
        How it works
      </button>
      <WelcomeModal open={open} onOpenChange={setOpen} />
    </>
  );
}
